const START = 1262322000000
let counter = 1

const ALPHABET79 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz.~:/#[]@!$&'()*+="

export const localId = () => counter++
export const timeId = () => Date.now() - START

const base79 = i64 => {
	const base = ALPHABET79.length
	let s = ''
	while (i64) {
		const mod = i64 % base
		i64 = Math.floor(i64 / base)
		s = ALPHABET79[mod] + s
	}
	return s
}


export const uuid = (time = timeId(), local = localId()) => {
	return base79(time) + base79(local)
}